export const actionTypes = {
  SET_AGENTLIST: "SET_AGENTLIST",
  SET_SALEAGENTLIST: "SET_SALEAGENTLIST",
  SET_AGENT_DETAIL: "SET_AGENT_DETAIL",
  SET_AGENT_SCORE: "SET_AGENT_SCORE",
  SET_AGENT_SUB_ACCOUNT_LIST: "SET_AGENT_SUB_ACCOUNT_LIST",
  SET_AGENT_TYPE_LIST: 'SET_AGENT_TYPE_LIST',
  SET_MESSAGE: "SET_MESSAGE",
  SET_AGENTLIST_STR_ID: "SET_AGENTLIST_STR_ID",
  SET_AGENT_OPTIONS: "SET_AGENT_OPTIONS",
};